import type { FC } from 'react';
import React from 'react';

import type { TControlledPropsDesktop } from './models';

export const ControlledModal: FC<TControlledPropsDesktop> = ({
    Modal,
    isOpen = false,
    ...modalProps
}) => (isOpen ? <Modal {...modalProps} /> : null);
